import { render, staticRenderFns } from "./ManageAnnouncements.vue?vue&type=template&id=3d587823&scoped=true"
import script from "./ManageAnnouncements.vue?vue&type=script&lang=js"
export * from "./ManageAnnouncements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d587823",
  null
  
)

export default component.exports